import Vue from "vue";
import Vuex from "vuex";
import createLogger from "vuex/dist/logger";
import user from "./modules/user";
import snackbar from "./modules/snackbar";
import dialog from "./modules/dialog";
import breadcrumbs from './modules/breadcrumbs'
import app from './modules/app'
import reportBreadcrumb from './modules/report-breadcrumb'
import reportBug from './modules/reportBug'
import secondFactor from '@colven/common-components'

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  modules: {
    app,
    user,
    snackbar,
    dialog,
    breadcrumbs,
    reportBreadcrumb,
    reportBug,
    secondFactor
  },
  strict: debug,
  plugins: debug ? [createLogger()] : []
});
